// extracted by mini-css-extract-plugin
module.exports = {"caption":"snackbar_caption__8_mfQ"};